module.exports = __webpack_public_path__ + "static/media/Group 25.712aa211.svg";